
import {Component, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Upload} from '@xmedical/core';
import {CoreService} from '../../../core/services/core.service';
import {UploadMenuItem} from '@xmedical/core';
import {UploadType} from '../file-uploader.service';

@Component({
    selector: 'app-files-folder-view',
    templateUrl: './files-folder-view.component.html',
    styleUrl: './files-folder-view.component.scss',
    standalone: false
})
export class FilesFolderViewComponent implements OnInit {
  private coreService = inject(CoreService);

  @Input() uploads: Upload[] = [];
  @Input() type: UploadType = 'practice';
  folders: UploadMenuItem[] = [];

  private practiceSettings = this.coreService.practiceSettings();

  ngOnInit() {
    this.folders = this.practiceSettings.uploadMenuItems;
  }

  get maxFolderColumns(): number {
    return this.practiceSettings.maxFolderColumns;
  }
}
